export const FETCH_CLAIMS_LIST = 'FETCH_CLAIMS_LIST';
export const SET_ROW_DETAILS = 'SET_ROW_DETAILS';
export const SET_CLAIM_DETAILS = 'SET_CLAIM_DETAILS';
